  window.acerillFormBuilderOnFormLoaded = function() {
    console.log('Acerill form loaded');

    // You can wrap the form or modify DOM here
    const formEl = document.querySelector('[data-acerill-form]');
    if (formEl) {
      formEl.classList.add('my-custom-form-class');
    }
  };




$(document).ready(function() {
    if ($(window).width() < 1200) { // Only initialize when width is below 1200px
        $('.product-listsss').slick({
            infinite: true,
            arrows: false,
            dots: true,
            slidesToShow: 3, // Default for tablets
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1024, // Tablets
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768, // Mobile
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
});









function toggleAccordion(header) {
        const content = header.nextElementSibling;
        const isActive = content.style.display === 'block';
  
        // Close all accordions
        document.querySelectorAll('.accordion-content').forEach(item => item.style.display = 'none');
        document.querySelectorAll('.accordion-heading').forEach(item => item.classList.remove('active'));
  
        // Toggle the clicked accordion
        if (!isActive) {
            content.style.display = 'block';
            header.classList.add('active');
        }
    }
$(document).ready(function() {
  // Initially hide all descriptions
  $('.refer-friend-before-container-faq-desc').hide();

  // Click event handler for the headings
  $('.refer-friend-before-container-faq-title').click(function() {
    var $parent = $(this).closest('.refer-friend-before-container-faq');
    var $desc = $parent.find('.refer-friend-before-container-faq-desc');

    // Toggle the description visibility
    $desc.slideToggle();

    // Add or remove class from the parent wrapper
    if ($parent.hasClass('active')) {
      $parent.removeClass('active');
    } else {
      // Optionally, hide other descriptions
      $('.refer-friend-before-container-faq-desc').not($desc).slideUp();
      $('.refer-friend-before-container-faq').not($parent).removeClass('active');
      $parent.addClass('active');
    }
  });
});













// Header Usp content slider
// $(document).ready(function(){
//     if ($(window).width() <= 1199) {
//       $('.af-usp-main').slick({
//         // Slick options
//         infinite: true,
//         arrows:true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 2000,
//       });
//     }
//   });

// Toggle content terms and condition
$(document).ready(function(){
    $('.af-rewards-terms-heading').click(function(){
        $('.af-rewards-terms-content').toggleClass('show');
        $('.af-rewards-terms-heading').toggleClass('move-arrow');
    });
});


// Ensure jQuery is loaded before this script runs
$(document).ready(function() {
  // Set the date we're counting down to
  var countDownDate = new Date("2024-06-16T24:00:00").getTime();

  // Update the count down every 1 second
  var x = setInterval(function() {

    // Get today's date and time
    var now = new Date().getTime();
    
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
    
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Output the result in the specified format and update the element
    $('#af-reward-timer').html(
      "<div class='af-days'><div class='af-variable-time'>" + days + "</div><div class='af-label'>Days</div></div> | " +
      "<div class='af-hours'><div class='af-variable-time'>" + hours + "</div><div class='af-label'>Hours</div></div> : " +
      "<div class='af-minutes'><div class='af-variable-time'>" + minutes + "</div><div class='af-label'>Minutes</div></div> : " +
      "<div class='af-seconds'><div class='af-variable-time'>" + seconds + "</div><div class='af-label'>Seconds</div></div>"
    );

    // If the count down is over, write some text 
    if (distance < 0) {
      clearInterval(x);
      $('#af-reward-timer').html("EXPIRED");
    }
  }, 1000);
});


// // Set the date we're counting down to
// var countDownDate = new Date("june 16, 2024 24:00:00").getTime();

// // Update the count down every 1 second
// var x = setInterval(function() {

//   // Get today's date and time
//   var now = new Date().getTime();
    
//   // Find the distance between now and the count down date
//   var distance = countDownDate - now;
    
//   // Time calculations for days, hours, minutes and seconds
//   var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//   var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//   var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//   var seconds = Math.floor((distance % (1000 * 60)) / 1000);

//   // Output the result in the specified format and update the element
//   $('#af-reward-timer').html(
//     "<div class='af-days'><div class='af-variable-time'>" + days + "</div><div class='af-label'>Days</div></div> | " +
//     "<div class='af-hours'><div class='af-variable-time'>" + hours + "</div><div class='af-label'>Hours</div></div> : " +
//     "<div class='af-minutes'><div class='af-variable-time'>" + minutes + "</div><div class='af-label'>Minutes</div></div> : " +
//     "<div class='af-seconds'><div class='af-variable-time'>" + seconds + "</div><div class='af-label'>Seconds</div></div>"
//   );

//   // If the count down is over, write some text 
//   if (distance < 0) {
//     clearInterval(x);
//     $('#af-reward-timer').html("EXPIRED");
//   }
// }, 1000);




$(document).ready(function() {

  // Attach the function to the button's click event on forgot button
  $(".forget-password").click(function() {
    setTimeout(function() {
      $("html, body").animate({ scrollTop: 0 }, "smooth");
    }, 1000); 
  });
  // open description tab as by default
  $("#tab-description-mobile").css("display", "block");
  $("#tab-customer-reviews-mobile").css("display", "block");
});
 // smile io button z-index change
 setTimeout(function() {
        $('#smile-ui-container').css('z-index','30');
    }, 5000); 
// empty input on clear button click
function clearInput() {
  var birthdayInput = document.getElementById('birthday');
  birthdayInput.setCustomValidity('');
  birthdayInput.value = '';
}
$('.af-show-hide_pass input').each(function(index) {
  var inputField = $(this);
  var eyeIcon = $('.af-eye-show_pass').eq(index);
  var isPasswordVisible = false;
  var eyeCloseIcon = $(".af-eye_close").eq(index);
  var eyeOpenIcon = $(".af-eye_open").eq(index);
  // Add click event listener to the eye icon
  eyeIcon.click(function() {
    if (isPasswordVisible) {
      inputField.attr('type', 'password');
      isPasswordVisible = false;
      eyeCloseIcon.hide();
      eyeOpenIcon.show();
    } else {
      inputField.attr('type', 'text');
      isPasswordVisible = true;
      eyeCloseIcon.show();
      eyeOpenIcon.hide();
    }
  });
});

// Validation for birthday field on register accoun page
function validateBirthday() {
  var birthdayInput = document.getElementById('birthday');
  var errorElement = document.getElementById('errorElement');
  var regex = /^(0[1-9]|1\d|2\d|3[01])-(0[1-9]|1[0-2])-\d{4}$/;

  if (!regex.test(birthdayInput.value)) {
    birthdayInput.setCustomValidity('Please enter your birthday in the format "dd-mm-yyyy".');
  } else {
    birthdayInput.setCustomValidity('');
  }
}



// Af Blog page js for numbering  
// const divs = document.querySelectorAll('.af-table-text');

// // Initialize counters
// let h2Counter = 0;
// let h3Counter = 0;

// // Loop through each div element
// divs.forEach((div, index) => {
//   const counter = document.createElement('span');
//   counter.classList.add('af-table-num');

//   // Check if the div contains an h2 or h3 element
//   const containsH2 = div.querySelector('h2');
//   const containsH3 = div.querySelector('h3');

//   if (containsH2) {
//     h2Counter++;
//     h3Counter = 0; // Reset h3 counter when encountering an h2
//     counter.textContent = h2Counter.toString();
//   } else if (containsH3) {
//     h3Counter++;
//     counter.textContent = `${h2Counter}.${h3Counter}`;
//   }

//   div.insertBefore(counter, div.firstChild);
// });


  const content = document.querySelector('.article-content'); // Adjust selector for your article content
  const tableRow = document.querySelector('.af-table-row');

  // Find all h2 and h3 headings in the content
  const headings = content.querySelectorAll('h2, h3');

  // Initialize counters for hierarchical numbering
  let h2Counter = 0;
  let h3Counter = 0;

  headings.forEach((heading, index) => {
    const tagName = heading.tagName.toLowerCase();

    // Create the table structure
    const div = document.createElement('div');
    div.classList.add('af-table-col');

    const innerDiv = document.createElement('div');
    innerDiv.classList.add('af-table-text');
    innerDiv.setAttribute('data-heading-level', tagName);

    // Create a span for the numbering
    const span = document.createElement('span');
    span.classList.add('af-table-num');

    // Update counters based on heading level
    if (tagName === 'h2') {
      h2Counter++;
      h3Counter = 0; // Reset h3 counter for a new h2
      span.textContent = `${h2Counter}.`;
    } else if (tagName === 'h3') {
      h3Counter++;
      span.textContent = `${h2Counter}.${h3Counter}`;
    }

    // Create the link
    const link = document.createElement('a');
    link.classList.add('scrollable-link');
    link.href = `#heading-${index}`;
    link.textContent = heading.textContent;

    // Append the span and the link to the inner div
    innerDiv.appendChild(span);
    innerDiv.appendChild(link);

    // Append the inner div to the table column
    div.appendChild(innerDiv);
    tableRow.appendChild(div);

    // Add ID to the heading for scrolling
    heading.id = `heading-${index}`;
  });



